<template>
  <div class="custom-divider bg-secondary-800 my-3" />
</template>

<script>
  export default {
    name: 'Divider'
  }
</script>

<style lang="scss" scoped>
.custom-divider {
  height: 1px;
}
</style>
